import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ThemeContextProvider from "./styles/theme";
import ReferralTracker from "./services/ReferralTracker";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeContextProvider>
    <BrowserRouter>
     <ReferralTracker />
      <App />
    </BrowserRouter>
  </ThemeContextProvider>
);
